/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Light response for day model
 * @export
 * @interface DayModelLightResponse
 */
export interface DayModelLightResponse {
    /**
     * Unique identifier of the day model
     * @type {string}
     * @memberof DayModelLightResponse
     */
    dayModelId?: string;
    /**
     * Name of day model
     * @type {string}
     * @memberof DayModelLightResponse
     */
    name?: string;
}

/**
 * Check if a given object implements the DayModelLightResponse interface.
 */
export function instanceOfDayModelLightResponse(value: object): value is DayModelLightResponse {
    return true;
}

export function DayModelLightResponseFromJSON(json: any): DayModelLightResponse {
    return DayModelLightResponseFromJSONTyped(json, false);
}

export function DayModelLightResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DayModelLightResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'dayModelId': json['dayModelId'] == null ? undefined : json['dayModelId'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function DayModelLightResponseToJSON(json: any): DayModelLightResponse {
    return DayModelLightResponseToJSONTyped(json, false);
}

export function DayModelLightResponseToJSONTyped(value?: DayModelLightResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dayModelId': value['dayModelId'],
        'name': value['name'],
    };
}

